import { createContext, useCallback, useContext, useMemo, useState, lazy, Suspense } from 'react';

const Toast = lazy(() => import('components/dialogs/Toast'));

const ToastContext = createContext({
  toast: () => {},
});

export function ToastContextProvider({ children }) {
  const [show, setShow] = useState(false);
  const [data, setData] = useState({
    message: undefined,
  });

  const toast = useCallback((message) => {
    setData({ message });
  }, []);

  const value = useMemo(() => {
    const val = {
      toast: (message) => {
        setData({ message });
        setShow(true);
      },
    };

    return val;
  }, [toast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {show && 
        <Suspense>
          <Toast setToast={setShow}>{data.message}</Toast>
        </Suspense>
      }
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  const context = useContext(ToastContext);
  return context;
}

export default useToastContext;
